export default __webpack_public_path__ + "static/media/Spin torre M_Interactive LightMix0060.7fd72645.webp";